// stocai_frontend/src/components/HomePage/components/widgets/Identity/FutureYou/FuturePersonaCard.jsx
import React from "react";
import starsImg from "../../../../../assets/stars.png";

/**
 * FuturePersonaCard
 * Props:
 *  - behaviours: array of strings
 *  - beliefs: array of strings
 *  - risks: array of strings
 */
const FuturePersonaCard = ({ behaviours = [], beliefs = [], risks = [] }) => {
  const behavioursList = behaviours && behaviours.length ? behaviours : [
    "Behaviour Trait 1 comes here",
    "Behaviour Trait 2 comes here",
    "Behaviour Trait 3 comes here",
  ];
  const beliefsList = beliefs && beliefs.length ? beliefs : [
    "Belief 1 comes here",
    "Belief 2 comes here",
    "Belief 3 comes here",
  ];
  const risksList = risks && risks.length ? risks : [
    "Risk taken 1 comes here",
    "Risk taken 2 comes here",
    "Risk taken 3 comes here",
  ];

  const containerStyle = {
    width: "429px",
    height: "712px",
    borderRadius: "21.09px",
    // exactly as Figma: two-layer gradient
    background:
      "linear-gradient(180deg, #FFFFFF 86.82%, #B9EBEA 100%)",
    backgroundRepeat: "no-repeat",
    border: "1.07px solid #54B0AF",
    boxShadow: "0 4px 8px rgba(0,0,0,0.06), 0 12px 24px rgba(0,0,0,0.12)",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  };

  const headerStyle = {
    width: "100%",
    height: "170px",
    background: "#0D1111",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
  };

  const titleStyle = {
    fontFamily: "Gotham, sans-serif",
    fontWeight: 700,
    fontSize: "21.39px",
    lineHeight: "100%",
    letterSpacing: "0%",
    textTransform: "uppercase",
    color: "#FFFFFF",
    textAlign: "center",
  };

  const sectionTitleStyle = {
    fontFamily: "Gotham, sans-serif",
    fontWeight: 500,
    fontSize: "12.84px",
    lineHeight: "145%",
    letterSpacing: "3%",
    textTransform: "uppercase",
    color: "#0C7F7D",
    textAlign: "left",
  };

  const itemTextStyle = {
    fontFamily: "Gotham, sans-serif",
    fontWeight: 400,
    fontSize: "14.67px",
    lineHeight: "165%",
    letterSpacing: "0%",
    color: "#323232",
    textAlign: "left",
  };

  const dividerStyle = {
    width: "332.886px",
    height: "0px",
    borderTop: "0.92px solid #DADADA",
    marginTop: "24px",
    marginBottom: "8px",
  };

  const starLeftStyle = {
    position: "absolute",
    left: "88px",
    top: "65px",
    width: "27.695px",
    height: "29.339px",
    transform: "rotate(-180deg)",
  };
  const starRightStyle = {
    position: "absolute",
    right: "88px",
    top: "65px",
    width: "27.695px",
    height: "29.339px",
    transform: "rotate(-180deg)",
  };

  // list container padding/indent to give heading-left + indented bullets
  const listContainerStyle = {
    paddingLeft: "18px", // indent bullets relative to heading
    paddingRight: "18px",
  };

  return (
    <div style={containerStyle}>
      {/* Header */}
      <div style={headerStyle}>
        <img src={starsImg} alt="stars-left" style={starLeftStyle} draggable={false} />
        <img src={starsImg} alt="stars-right" style={starRightStyle} draggable={false} />
        <div style={titleStyle}>
          <div>Your Future</div>
          <div>Persona</div>
        </div>
      </div>

      {/* Body (scrollable so card is never cut off) */}
      <div
        className="flex-1 overflow-y-auto"
        style={{ paddingTop: "36px", paddingBottom: "32px", paddingLeft: "40px", paddingRight: "40px", background: "transparent" }}
      >
        {/* New Behaviors */}
        <section style={{ marginBottom: "32px" }}>
          <p style={sectionTitleStyle}>New Behaviors</p>

          <div style={listContainerStyle}>
            <ul className="list-disc" style={{ marginTop: "10px", paddingLeft: "18px" }}>
              {behavioursList.map((it, idx) => (
                <li key={`beh-${idx}`} style={itemTextStyle}>
                  {it}
                </li>
              ))}
            </ul>
            <div style={dividerStyle} />
          </div>
        </section>

        {/* New Beliefs */}
        <section style={{ marginBottom: "32px" }}>
          <p style={sectionTitleStyle}>New Beliefs</p>

          <div style={listContainerStyle}>
            <ul className="list-disc" style={{ marginTop: "10px", paddingLeft: "18px" }}>
              {beliefsList.map((it, idx) => (
                <li key={`bel-${idx}`} style={itemTextStyle}>
                  {it}
                </li>
              ))}
            </ul>
            <div style={dividerStyle} />
          </div>
        </section>

        {/* Risks Taken */}
        <section>
          <p style={sectionTitleStyle}>Risks Taken</p>

          <div style={listContainerStyle}>
            <ul className="list-disc" style={{ marginTop: "10px", paddingLeft: "18px" }}>
              {risksList.map((it, idx) => (
                <li key={`risk-${idx}`} style={itemTextStyle}>
                  {it}
                </li>
              ))}
            </ul>
          </div>
        </section>
      </div>
    </div>
  );
};

export default FuturePersonaCard;